"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmAppointmentFooter = exports.ConfirmAppointmentBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const LoadingButton_1 = __importDefault(require("../../../components/LoadingButton"));
const axios_1 = __importDefault(require("axios"));
const react_query_1 = require("@tanstack/react-query");
const dayjs_1 = __importDefault(require("dayjs"));
const ConfirmAppointmentBody = ({ appointment, status, }) => {
    const { fromDate, location } = appointment;
    const modalBody = (0, react_1.useMemo)(() => {
        switch (status) {
            case 'OK':
                return (0, jsx_runtime_1.jsx)("h4", { children: __.trans('booking.confirmation-successful') });
            case 'ERROR':
                return (0, jsx_runtime_1.jsx)("h4", { className: "text-danger", children: __.trans('booking.confirmation-unsuccessful') });
            default:
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h4", { children: __.trans('booking.modal-time') }), (0, jsx_runtime_1.jsx)("p", { className: "capitalize", children: `${(0, dayjs_1.default)(fromDate).format('dddd D MMMM YYYY')}, kl. ${(0, dayjs_1.default)(fromDate).format('HH:mm')}` })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h4", { children: __.trans('booking.blood-central') }), (0, jsx_runtime_1.jsx)("p", { children: location.name })] }), (0, jsx_runtime_1.jsx)("div", { className: "booking-info-text", children: (0, jsx_runtime_1.jsx)("p", { children: __.trans('booking.modal-info-cancelation-text') }) })] }));
        }
    }, [fromDate, location.name, status]);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: modalBody });
};
exports.ConfirmAppointmentBody = ConfirmAppointmentBody;
const ConfirmAppointmentFooter = ({ appointment, toggleBookingModal, setIsLoading, handleStatusChange, isLoading, status, }) => {
    const { appointmentId } = appointment;
    const queryClient = (0, react_query_1.useQueryClient)();
    const confirm = (0, react_1.useCallback)(() => {
        setIsLoading(true);
        axios_1.default
            .post('/api/booking/confirm-appointment', { existingAppointmentId: appointmentId })
            .then((response) => {
            handleStatusChange(response.data.replyStatus.status);
            queryClient.invalidateQueries({ queryKey: ['get-coming-appointments'] });
        })
            .catch((error) => {
            handleStatusChange(error.response.data.replyStatus.status);
        });
    }, [appointmentId, queryClient, handleStatusChange, setIsLoading]);
    const handleClose = (0, react_1.useCallback)(() => {
        handleStatusChange(undefined);
        toggleBookingModal();
    }, [handleStatusChange, toggleBookingModal]);
    const modalFooter = (0, react_1.useMemo)(() => {
        switch (status) {
            case 'OK':
                return ((0, jsx_runtime_1.jsx)(LoadingButton_1.default, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-sm theme-button-primary button-cancel", onClick: handleClose, children: __.trans('booking.modal-close') }) }));
            case 'ERROR':
                return ((0, jsx_runtime_1.jsx)(LoadingButton_1.default, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-sm theme-button-primary button-cancel", onClick: handleClose, children: __.trans('booking.modal-close') }) }));
            default:
                return ((0, jsx_runtime_1.jsx)(LoadingButton_1.default, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-sm theme-button-primary button-confirm", onClick: confirm, children: __.trans('booking.confirm') }) }));
        }
    }, [confirm, isLoading, status, handleClose]);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: modalFooter });
};
exports.ConfirmAppointmentFooter = ConfirmAppointmentFooter;
